import { ResponseDto } from "@common/ict/model/interface/common";
import { UserInfoDto } from '@common/ict/model/interface/user';
import { AxiosInstance } from 'axios';

const baseLoginUrl = "api/v1.0/IctUserService";

export function getUserInfoApi(request: AxiosInstance) {
  return request.get<ResponseDto<UserInfoDto>, ResponseDto<UserInfoDto>>(
    `${baseLoginUrl}/GetUserInfo`
  );
}
